/**
 * DJI México - 首页埋点（page_type=home）
 * ==================================================================
 * 严格按《数据埋点定义文档》Homepage 实施清单表（H2–H8）实施。
 * Header 与搜索链路见 dji-tracking-header.js，不在此重复。
 *
 *   H2 主 banner slide 曝光      view_promotion            P0 L2
 *   H2 主 banner CTA             select_promotion          P0 L2
 *   H2 主 banner 手动轮播        carousel_interaction      P1 L2
 *   H2 banner 邮件订阅           generate_lead             P0 L3
 *   H3 产品系列横滑入口          category_entry_click      P0 L2
 *   H4 服务与支持卡片            service_card_open         P1 L3
 *   H4 服务 Modal 的 Aprende más service_learn_more_click  P0 L3
 *   H5 品类推广 Hero 曝光        view_promotion            P0 条件 L2
 *   H5 品类推广 Hero 的 Comprar  select_promotion          P0 条件 L2
 *   H6 商品列表曝光              view_item_list            P0 L1/L2
 *   H6 商品卡进 PDP              select_item               P0 L1
 *   H6 商品卡快速加购            add_to_cart               P0 条件 L1
 *   H7 编辑型品类 CTA            category_entry_click      P0 L2
 *   H8 首页阅读深度              home_scroll_depth         P1 L2
 *
 * ------------------------------------------------------------------
 * 为什么不再用 section id 登记表（上一版最大的错误）
 * ------------------------------------------------------------------
 * 线上实测（2026-08-25，390×844）：首页 34 个 section 中 32 个带 pf-hide，
 * `@media (max-width:767.4999px){.__pf .pf-hide{display:none!important}}`
 * 让它们在移动端全部 display:none；移动端只渲染 pf-e454 与 pf-71db 两个 section。
 * 上一版 MAP 登记的 11 个 section 全在被隐藏那批——移动端 14 行里 13 行归零。
 *
 * 改为按 PageFly 的语义结构识别（data-pf-type / data-pf-popup-target /
 * data-product-id / data-href）。同一套探针在 390 与 1440 两个断点结果一致，
 * 且 PageFly 重新发布换掉 section id 也不会失效。
 *
 * DOM 依据见 选择器契约-线上实测.md
 */
(function (w, d) {
  'use strict';

  var DL = w.DJIDataLayer;
  if (!DL) return;
  if ((DL.ctx.page_type || '') !== 'home') return;
  if (w.__djiHomeTracking) return;      /* 幂等：重复注入不重复绑定 */
  w.__djiHomeTracking = 1;

  /* ================================================================ */
  /* 表格指定的 component_id / placement                               */
  /* ================================================================ */

  var C = {
    hero:      { component_id: 'home_hero',                placement: 'hero_slide_' },   /* + {n} */
    carousel:  { component_id: 'home_hero',                placement: 'hero_carousel' },
    newsletter:{ component_id: 'home_hero_newsletter',     placement: 'home_hero' },
    seriesNav: { component_id: 'home_series_nav',          placement: 'home_series_carousel' },
    service:   { component_id: 'service_support',          placement: 'home_service_grid' },
    serviceMd: { component_id: 'service_support_modal',    placement: 'home_service_modal' },
    catHero:   { component_id: 'home_category_hero',       placement: 'home_category_hero_' }, /* + {n} */
    grid:      { component_id: 'home_product_grid',        placement: 'home_product_grid_' },  /* + {name} */
    editorial: { component_id: 'home_editorial_category',  placement: 'home_editorial_' },     /* + {name} */
    scroll:    { component_id: 'home_content',             placement: 'home_document' }
  };

  /* PageFly 语义结构 —— 全部经线上实测 */
  var PF = {
    slideshow:  '[data-pf-type="Slideshow"]',
    slide:      '[data-pf-type="SlideshowSlide"]',
    sliderTrack:'.pf-slider',
    sliderPrev: '.pf-slider-prev',
    sliderNext: '.pf-slider-next',
    sliderDots: '.pf-slider-nav > *',
    contentList:'[data-pf-type="ContentList2"]',
    contentItem:'[data-pf-type="ContentListItem"]',
    popupTrig:  '[data-pf-popup-target][data-action="popup-element"]',
    popupOpen:  '.pf-popup-overlay, .pf-popup-dialog',
    productBox: '[data-pf-type="ProductBox"]',
    heading:    '[data-pf-type="Heading2"]',
    newsletter: 'form[action*="/contact"]',
    colLink:    '[data-href*="/collections/"]',
    flex:       '[data-pf-type="FlexBlock"]'
  };

  /* 服务卡按「触发器文案」取 service_id：移动端与桌面端的 popup UUID 是两套，
     且移动端有两张卡共用同一个 UUID，UUID 不是唯一键；文案两个断点一致。 */
  var SERVICE_IDS = [
    [/env[íi]o\s+gratis/i,                'free_shipping'],
    [/devoluci[óo]n/i,                    'returns_30_days'],
    [/12\s*meses|meses\s+para\s+pagar/i,  'installments'],
    [/paga\s+despu[ée]s/i,                'buy_now_pay_later'],
    [/aut[ée]nticos|reacondicionad/i,     'authentic_refurbished'],
    [/asesor[íi]a|expertos/i,             'expert_advice'],
    [/cr[ée]ditos/i,                      'dji_credits'],
    [/env[íi]o\s+r[áa]pido|bodega/i,      'fast_shipping_mx']
  ];

  /* 商品网格按标题取语义名 */
  var GRID_NAMES = [
    [/drones?\s+con\s+c[áa]mara/i,    'camera_drones'],
    [/dispositivos\s+port[áa]tiles/i, 'handheld'],
    [/estabilizadores/i,              'stabilizers'],
    [/energ[íi]a\s+port[áa]til/i,     'power']
  ];

  /* ================================================================ */
  /* 工具                                                              */
  /* ================================================================ */

  function all(root, sel) { return root ? [].slice.call(root.querySelectorAll(sel)) : []; }
  function txt(el) { return el && el.innerText ? el.innerText.trim().replace(/\s+/g, ' ').slice(0, 80) : ''; }

  function visible(el) {
    if (!el) return false;
    var r, s;
    try { r = el.getBoundingClientRect(); s = w.getComputedStyle(el); } catch (e) { return false; }
    return s.display !== 'none' && s.visibility !== 'hidden' && r.width > 0 && r.height > 0;
  }

  function topOf(el) { return el.getBoundingClientRect().top + (w.pageYOffset || 0); }

  function slug(t) {
    return String(t || '').toLowerCase()
      .replace(/[áàä]/g, 'a').replace(/[éèë]/g, 'e').replace(/[íìï]/g, 'i')
      .replace(/[óòö]/g, 'o').replace(/[úùü]/g, 'u').replace(/ñ/g, 'n')
      .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 40);
  }

  function matchTable(table, text, fallback) {
    for (var i = 0; i < table.length; i++) if (table[i][0].test(text)) return table[i][1];
    return fallback;
  }

  function hrefOf(el) {
    if (!el) return '';
    return el.getAttribute('data-href') || el.getAttribute('href') || '';
  }

  function handleOf(href) {
    var m = String(href || '').match(/\/(?:products|collections)\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function destType(href) {
    if (/\/collections\//.test(href || '')) return 'collection';
    if (/\/products\//.test(href || '')) return 'product';
    if (/\/pages\//.test(href || '')) return 'campaign';
    return undefined;
  }

  function base(componentId, placement, extra) {
    var out = { page_type: 'home', component_id: componentId, placement: placement };
    for (var k in (extra || {})) out[k] = extra[k];
    return out;
  }

  function productIdOf(box) {
    if (!box) return '';
    var v = box.getAttribute && box.getAttribute('data-product-id');
    if (v) return v;
    var inner = box.querySelector && box.querySelector('[data-product-id]');
    return inner ? inner.getAttribute('data-product-id') : '';
  }

  /* 统一点击委托：window 捕获阶段。PageFly 在冒泡阶段 stopPropagation，
     window 捕获是传播链上最早的一层，不会被截断。 */
  var handlers = [];
  function onClick(fn) { handlers.push(fn); }
  w.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    for (var i = 0; i < handlers.length; i++) {
      try { if (handlers[i](evt, t) === true) return; } catch (e) { DL.log('home click handler error', e); }
    }
  }, true);

  /* ================================================================ */
  /* 结构发现                                                          */
  /* ================================================================ */

  var MODULES = { hero: null, newsletterForms: [], seriesLists: [], serviceTriggers: [], grids: [], catHeroes: [], editorialLinks: [] };

  /**
   * 结构发现。全部经线上实测（390×844 与 1440×900 各跑一遍）。
   *
   * ⚠️ 分组必须按 DOM 文档顺序，不能按像素位置：
   * PageFly 懒加载会持续改变元素高度，同一个页面先后两次按 top 排序分组，
   * 结果会不一样（实测出现过 4 组变 2 组、名字退化的情况）。
   *
   * ⚠️ 网格标题只认 GRID_NAMES 命中的那些：
   * 桌面端品类推广 Hero 自己也有一个 Heading2（"DJI Mini 5 Pro" 等），
   * 在 DOM 顺序上夹在网格标题与商品卡之间，会把网格标题劫持掉。
   * 表格本来就只定义了这 4 个商品列表，以表为准反而最稳。
   */
  function discover() {
    var m = { hero: null, newsletterForms: [], seriesLists: [], serviceTriggers: [], grids: [], catHeroes: [], editorialLinks: [] };

    /* H2 主 banner：第一个可见的 Slideshow */
    m.hero = all(d, PF.slideshow).filter(visible)[0] || null;

    /* H2 订阅表单：hero 所在 section 内的 /contact 表单 */
    /* ⚠️ hero 没发现时不能退化成整个 document：
       Footer 的订阅表单同样是 form[action*="/contact"]，会被当成 hero 表单绑上
       __djiNl（永久标记，后续 wire 不再重绑），用户从 Footer 订阅时写入
       {src:'home_hero'}，两边的订阅事件双双丢失。 */
    var heroSection = m.hero ? m.hero.closest('section[data-section-id]') : null;
    m.newsletterForms = heroSection
      ? all(heroSection, PF.newsletter).filter(function (f) {
          return visible(f) && !f.closest('footer, #shopify-section-footer, [class*="dji-ft"]');
        })
      : [];

    /* H3 系列导航 */
    m.seriesLists = all(d, PF.contentList).filter(visible);

    /* H4 服务卡片 */
    m.serviceTriggers = all(d, PF.popupTrig).filter(visible);

    /* H5 + H6：按文档顺序单次遍历 Heading2 / ProductBox / 大尺寸媒体。
       品类推广 Hero 两个断点形态不同，都要接住：
         桌面端 —— 有自己的 Heading2（"DJI Mini 5 Pro" 等）
         移动端 —— 没有 Heading2，是一个 425px 的视频块
       共同点是都位于「网格标题之后、首个商品卡之前」，用这个窗口统一判定。 */
    var byName = {};
    var cur = null;
    var lastHeadText = '';
    all(d, PF.heading + ',' + PF.productBox + ',video,img').forEach(function (n) {
      var pfType = n.getAttribute('data-pf-type');

      if (pfType === 'Heading2') {
        if (!visible(n)) return;
        if (n.closest(PF.slideshow) || n.closest(PF.contentList)) return;  /* 轮播与系列导航的标题不算 */
        var t = txt(n);
        lastHeadText = t;
        var name = matchTable(GRID_NAMES, t, null);
        if (name) {
          if (!byName[name]) {
            byName[name] = { name: name, title: t, item_list_name: 'Home - ' + t, boxes: [], promoEl: null, promoTxt: null };
            m.grids.push(byName[name]);
          }
          cur = byName[name];
        } else if (cur && !cur.boxes.length && !cur.promoTxt) {
          /* ⚠️ 只认这个窗口：放宽到「商品卡之后」会把 FAQ 标题误判成 Hero */
          cur.promoEl = cur.promoEl || n.closest(PF.flex) || n;
          cur.promoTxt = t;
        }
        return;
      }

      if (pfType === 'ProductBox') {
        if (!visible(n)) return;
        /* ⚠️ 降级：GRID_NAMES 未命中时不能静默丢弃商品卡。
           运营把「Drones con Cámara」改个字，上一版会让 H6 三个事件
           （view_item_list / select_item / add_to_cart）整组归零，
           而且日志里只有 grids: [] 一行，没有任何告警。
           这里按最近的标题文案生成一个 slug 组，并打一条告警日志。 */
        if (!cur) {
          var t2 = lastHeadText || 'Home';
          var nm = slug(t2) || 'grid';
          if (!byName[nm]) {
            byName[nm] = { name: nm, title: t2, item_list_name: 'Home - ' + t2,
                           boxes: [], promoEl: null, promoTxt: null, fallback: true };
            m.grids.push(byName[nm]);
            DL.log('home: 网格标题未命中 GRID_NAMES，已降级为 "' + nm + '"，请核对表格取值', t2);
          }
          cur = byName[nm];
        }
        cur.boxes.push(n);
        return;
      }

      /* video / img：移动端形态的品类 Hero */
      if (!cur || cur.boxes.length || cur.promoEl) return;
      if (n.closest(PF.productBox) || n.closest(PF.contentList) || n.closest(PF.slideshow)) return;
      if (!visible(n)) return;
      if (n.getBoundingClientRect().height < 180) return;
      var block = n.closest(PF.flex);
      if (!block || block.querySelector(PF.productBox)) return;
      cur.promoEl = block;
      if (!cur.promoTxt) cur.promoTxt = txt(block).slice(0, 60);
    });

    m.grids.forEach(function (g) {
      if (!g.promoEl) return;
      m.catHeroes.push({ el: g.promoEl, n: m.catHeroes.length + 1, grid: g, name: g.promoTxt });
    });

    /* H7 编辑型品类 CTA */
    m.editorialLinks = all(d, PF.colLink).filter(function (el) {
      return visible(el) && !el.closest(PF.contentList) && !el.closest(PF.productBox);
    });

    return m;
  }

  /** 一组元素的最近共同祖先 */
  function commonAncestor(els) {
    if (!els || !els.length) return null;
    var a = els[0];
    for (var i = 1; i < els.length; i++) {
      var b = els[i];
      while (a && !a.contains(b)) a = a.parentElement;
      if (!a) return els[0].parentElement;
    }
    return a;
  }

  /** 商品卡点击的 element_id（表格枚举 product_card|product_title|product_image） */
  function elementIdOfCardClick(t, box) {
    if (t.closest('img, picture, [data-pf-type="ProductMedia3"], [data-pf-type="MediaMain3"]')) return 'product_image';
    if (t.closest('[data-pf-type="ProductTitle"], h1, h2, h3, [class*="title"]')) return 'product_title';
    return 'product_card';
  }

  function gridOf(el) {
    var gs = MODULES.grids;
    for (var i = 0; i < gs.length; i++) {
      for (var j = 0; j < gs[i].boxes.length; j++) {
        var b = gs[i].boxes[j];
        if (b === el || b.contains(el)) return { g: gs[i], box: b, index: j + 1 };
      }
    }
    return null;
  }

  /* ================================================================ */
  /* H2 · 主 banner                                                    */
  /* ================================================================ */

  function slotOf(slide) {
    var show = slide.closest(PF.slideshow) || slide.parentElement;
    var i = all(show, PF.slide).indexOf(slide);
    return i > -1 ? i + 1 : 1;
  }

  function heroInfo(slide) {
    var slot = slotOf(slide);
    var cta = slide.querySelector('[data-href], a[href]');
    var href = hrefOf(cta);
    return {
      slot: slot,
      cta: cta,
      promotion_id: 'home_hero_slot_' + slot,
      promotion_name: txt(slide.querySelector('h1,h2,h3,' + PF.heading)) || 'home_hero_slot_' + slot,
      creative_slot: 'hero_slide_' + slot,
      creative_name: handleOf(href) || undefined,
      destination_url: href || undefined
    };
  }

  function initHero(hero) {
    if (!hero || hero.__djiHero) return;
    hero.__djiHero = 1;

    all(hero, PF.slide).forEach(function (slide) {
      DL.observe(slide, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
        var p = heroInfo(el);
        if (!DL.once('view_promotion|' + p.promotion_id)) return;
        DL.push('view_promotion', base(C.hero.component_id, 'hero_slide_' + p.slot, {
          promotion_id: p.promotion_id,
          promotion_name: p.promotion_name,
          creative_name: p.creative_name,
          creative_slot: p.creative_slot,
          destination_url: p.destination_url,
          exposure_rule: meta.rule,
          exposure_ratio: meta.ratio_observed
        }));
      });
    });

    onClick(function (evt, t) {
      var slide = t.closest(PF.slide);
      if (!slide || !hero.contains(slide)) return;
      if (t.closest(PF.sliderPrev) || t.closest(PF.sliderNext) || t.closest(PF.sliderDots)) return;
      var p = heroInfo(slide);
      var cta = t.closest('[data-href], a[href]') || p.cta;
      var href = hrefOf(cta) || p.destination_url;
      if (!href) return;
      DL.afterTick(function () {
        var __np = DL.navPush(evt, cta || slide);
        if (!__np) return;
        __np('select_promotion', base(C.hero.component_id, 'hero_slide_' + p.slot, {
          promotion_id: p.promotion_id,
          element_id: 'hero_cta',
          cta_label: txt(cta) || undefined,
          destination_url: href
        }));
      });
      return true;
    });

    initCarousel(hero);
  }

  /**
   * H2 手动轮播。
   *
   * ⚠️ 实测：slide 上没有 .pf-active / aria-hidden / data-active 任何活跃标记。
   * .pf-slider 是横向滚动容器（scrollWidth 1520 / clientWidth 380，
   * slide 分布在 x=0/380/760/1140），当前页只能按 scrollLeft 算。
   *
   * ⚠️ 滑动手势不产生 click，只产生 scroll —— 这是移动端最主要的翻页方式，
   * 上一版只监听按钮点击，整个漏掉。这里同时接住点击与滚动，
   * 并用「800ms 内有没有用户交互」区分手动翻页与自动轮播（自动的按表格不上报）。
   */
  function initCarousel(hero) {
    var track = hero.querySelector(PF.sliderTrack);
    if (!track || track.__djiCarousel) return;
    track.__djiCarousel = 1;

    function count() { return all(hero, PF.slide).length || 1; }
    function currentSlot() {
      var wid = track.clientWidth || 1;
      return Math.min(count(), Math.max(1, Math.round(track.scrollLeft / wid) + 1));
    }

    var last = currentSlot();
    var action = null, actionAt = 0, settle = null;

    /* ⚠️ 表格枚举是 action=next|previous|dot，只写了「点击箭头或圆点」。
       但移动端是原生 scroll-snap，滑动不产生 click —— 不接 swipe 会让
       移动端这一行几乎没有数据。这里保留 swipe 作为表外补充值，
       需要数据侧确认是否纳入枚举；不接受的话把下面三个 markUser('swipe') 去掉即可。 */

    function markUser(a) { action = a; actionAt = Date.now(); }

    function emit() {
      var now = currentSlot();
      if (now === last) return;
      var from = last;
      last = now;
      /* ⚠️ 800ms 太短：PageFly 的翻页是平滑滚动，1430px 的一屏要滚 ~700ms+，
         scroll 停稳再等 180ms 才判定，实测点了 next 却因为「超时」被当成自动轮播丢掉。
         放宽到 3s —— 仍然足够把真正的自动轮播（无任何用户交互）挡在外面。 */
      if (!action || Date.now() - actionAt > 3000) return;   /* 自动轮播不上报 */
      var a = action;
      action = null;
      DL.push('carousel_interaction', base(C.carousel.component_id, C.carousel.placement, {
        action: a,
        from_slide: from,
        to_slide: now,
        promotion_id: 'home_hero_slot_' + now
      }));
    }

    track.addEventListener('scroll', function () {
      if (settle) w.clearTimeout(settle);
      settle = w.setTimeout(emit, 180);      /* 等滚动停稳再判落点 */
    }, { passive: true });

    ['touchstart', 'pointerdown', 'mousedown'].forEach(function (ev) {
      track.addEventListener(ev, function () { markUser('swipe'); }, { passive: true });
    });
    track.addEventListener('wheel', function () { markUser('swipe'); }, { passive: true });

    onClick(function (evt, t) {
      if (!hero.contains(t)) return;
      if (t.closest(PF.sliderPrev)) { markUser('previous'); return true; }
      if (t.closest(PF.sliderNext)) { markUser('next'); return true; }
      if (t.closest(PF.sliderDots)) { markUser('dot'); return true; }
    });
  }

  /* ================================================================ */
  /* H2 · banner 邮件订阅                                              */
  /* ================================================================ */

  /**
   * ⚠️ 实测：首页 hero 订阅表单的 form_type 是 customer，与 Footer 订阅表单完全相同，
   * 页面上三个 /contact 表单全部是 customer。Shopify 让同 form_type 的所有表单
   * 同时 posted_successfully? 为 true，回跳参数也都是 ?customer_posted=true。
   *
   * 所以不能靠 URL 参数判断是谁提交的 —— 上一版会把 Footer 订阅记成 hero 订阅。
   * 改为在 submit 捕获阶段把来源写进 sessionStorage，跳转后回读并立即清除。
   */
  /* ⚠️ 必须与 Footer 用**不同的键**。
     模块加载顺序是 header → footer → home（见 dji-datalayer-init.liquid），
     且两个表单 form_type 都是 customer —— hero 提交成功时 Footer 的成功标记
     同样会渲染，footer 模块会先读到并无条件删掉共享键，
     等 home 跑到时读到 null，首页 generate_lead 恒为 0。 */
  var NL_KEY = 'dji_nl_home';

  function initNewsletter(forms) {
    forms.forEach(function (f) {
      if (f.__djiNl) return;
      f.__djiNl = 1;
      f.addEventListener('submit', function () {
        try { w.sessionStorage.setItem(NL_KEY, JSON.stringify({ src: 'home_hero', at: Date.now() })); } catch (e) {}
      }, true);
    });
  }

  function emitNewsletterSuccess() {
    if (!/[?&]customer_posted=true/.test(w.location.search)) return;
    var rec = null;
    try {
      rec = JSON.parse(w.sessionStorage.getItem(NL_KEY) || 'null');
      w.sessionStorage.removeItem(NL_KEY);   /* 无论归谁都清掉，避免污染下一次 */
    } catch (e) {}
    if (!rec || rec.src !== 'home_hero') return;       /* Footer 提交的，不归首页 */
    if (Date.now() - (rec.at || 0) > 120000) return;
    if (!DL.onceSession('home_newsletter|' + rec.at)) return;

    DL.push('generate_lead', base(C.newsletter.component_id, C.newsletter.placement, {
      form_id: 'home_hero_newsletter',
      lead_type: 'newsletter',
      subscription_source: 'home_hero',
      result: 'success'
      /* 邮箱不进 dataLayer */
    }));
  }

  /* ================================================================ */
  /* H3 · 产品系列横滑入口                                             */
  /* ================================================================ */

  function initSeriesNav(lists) {
    lists.forEach(function (list) {
      if (list.__djiSeries) return;
      list.__djiSeries = 1;

      onClick(function (evt, t) {
        var item = t.closest(PF.contentItem);
        if (!item || !list.contains(item)) return;
        var link = item.matches('[data-href]') ? item : item.querySelector('[data-href], a[href]');
        var href = hrefOf(link) || hrefOf(item);
        if (!href) return;
        var idx = all(list, PF.contentItem).indexOf(item);

        /* 实测：桌面端 ContentListItem 内只有 <img>、innerText 为空，移动端有文案。
           依次回退 文案 → img alt → href handle，保证 category_name 不缺失。 */
        var name = txt(item);
        if (!name) {
          var img = item.querySelector('img');
          var alt = img ? (img.getAttribute('alt') || '') : '';
          if (alt && !/\.(jpe?g|png|webp|svg)|__PID:/i.test(alt)) name = alt.trim().slice(0, 40);
        }
        if (!name) name = handleOf(href).replace(/-/g, ' ');

        DL.afterTick(function () {
          var __np = DL.navPush(evt, link || item);
          if (!__np) return;
          __np('category_entry_click', base(C.seriesNav.component_id, C.seriesNav.placement, {
            category_id: handleOf(href) || undefined,
            category_name: name || undefined,
            destination_type: destType(href),
            destination_url: href,
            index: idx > -1 ? idx + 1 : undefined
          }));
        });
        return true;
      });
    });
  }

  /* ================================================================ */
  /* H4 · 服务与支持                                                   */
  /* ================================================================ */

  function popupOpen() {
    var list = all(d, PF.popupOpen).filter(visible);
    return list.length ? list[list.length - 1] : null;
  }

  var openService = null;

  function initService() {
    if (initService.__bound) return;
    initService.__bound = 1;

    onClick(function (evt, t) {
      var trig = t.closest(PF.popupTrig);
      if (!trig) return;
      var label = txt(trig);
      var sid = matchTable(SERVICE_IDS, label, slug(label) || 'service');
      var uuid = trig.getAttribute('data-pf-popup-target') || '';
      var idx = all(d, PF.popupTrig).filter(visible).indexOf(trig);

      /* 表格：弹层实际打开才算。等 DOM 里真的出现「新的」可见弹层，
         用 before/now 比对，避免页面上已有别的弹层时误判。 */
      var before = popupOpen();
      var tries = 0;
      (function wait() {
        var now = popupOpen();
        if (now && now !== before) {
          openService = { id: sid, name: label, modal: now, uuid: uuid };
          DL.push('service_card_open', base(C.service.component_id, C.service.placement, {
            service_id: sid,
            service_name: label || undefined,
            index: idx > -1 ? idx + 1 : undefined,
            modal_id: uuid || undefined
          }));
          return;
        }
        if (++tries < 25) w.setTimeout(wait, 120);
        /* 3 秒内没打开：加载失败或被拦截，按表格不触发 */
      })();
      return true;
    });

    /* Aprende más：必须在弹层内，且用弹层自身校验来源，不只信模块级变量 */
    onClick(function (evt, t) {
      var modal = t.closest(PF.popupOpen);
      if (!modal) return;
      var link = t.closest('[data-href], a[href]');
      if (!link) return;
      var label = txt(link);
      if (!/aprende|learn|conoce|saber\s+m[áa]s|ver\s+m[áa]s/i.test(label)) return;
      var svc = (openService && openService.modal === modal)
        ? openService
        : { id: matchTable(SERVICE_IDS, txt(modal), 'service'), name: txt(modal.querySelector('h1,h2,h3')) };
      var href = hrefOf(link);
      DL.afterTick(function () {
        if (!DL.isInteractive(link)) return;
        DL.push('service_learn_more_click', base(C.serviceMd.component_id, C.serviceMd.placement, {
          service_id: svc.id,
          service_name: svc.name || undefined,
          element_id: 'learn_more',
          destination_url: href || undefined
        }));
      });
      return true;
    });
  }

  /* ================================================================ */
  /* H5 · 品类推广 Hero                                                */
  /* ================================================================ */

  function initCategoryHero(heroes) {
    heroes.forEach(function (h) {
      if (h.el.__djiCatHero) return;
      h.el.__djiCatHero = 1;

      var placement = C.catHero.placement + h.n;
      var pid = 'home_category_hero_' + (h.n < 10 ? '0' + h.n : h.n);
      var link = h.el.querySelector('[data-href], a[href]');
      var href = hrefOf(link);
      var pname = h.name || txt(h.el.querySelector('h1,h2,h3,' + PF.heading)) || (h.grid ? h.grid.title : pid);

      DL.observe(h.el, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
        if (!DL.once('view_promotion|' + pid)) return;
        DL.push('view_promotion', base(C.catHero.component_id, placement, {
          promotion_id: pid,
          promotion_name: pname,
          destination_type: destType(href),
          destination_url: href || undefined,
          exposure_rule: meta.rule,
          exposure_ratio: meta.ratio_observed
        }));
      });

      onClick(function (evt, t) {
        if (!h.el.contains(t)) return;
        var cta = t.closest('[data-href], a[href]');
        if (!cta) return;
        var chref = hrefOf(cta);
        if (!chref) return;
        DL.afterTick(function () {
          var __np = DL.navPush(evt, cta);
          if (!__np) return;
          __np('select_promotion', base(C.catHero.component_id, placement, {
            promotion_id: pid,
            element_id: 'hero_cta',
            cta_label: txt(cta) || undefined,
            destination_type: destType(chref),
            destination_url: chref
          }));
        });
        return true;
      });
    });
  }

  /* ================================================================ */
  /* H6 · 商品列表                                                     */
  /* ================================================================ */

  var lastAdd = null;

  function gridItem(box, g, index) {
    var pid = productIdOf(box);
    if (!pid) return null;
    return DL.item(pid, {
      index: index,
      item_list_id: 'home_' + g.name,
      item_list_name: g.item_list_name,
      variant_id: box.getAttribute('data-default-variant') || undefined
    });
  }

  function initGrids(grids) {
    grids.forEach(function (g) {
      /* ⚠️ boxes[0].parentElement 只包住第一张卡（实测 PageFly 结构是
         FlexBlock > FlexBlock > FlexBlock > ProductBox），
         用它做曝光锚点会在第一张卡露出一半时就上报整组商品，口径系统性提前。
         改用该组所有商品卡的共同祖先。 */
      var host = commonAncestor(g.boxes);
      if (!host || host.__djiGrid) return;
      host.__djiGrid = 1;

      var listId = 'home_' + g.name;
      var placement = C.grid.placement + g.name;

      DL.observe(host, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
        if (!DL.once('view_item_list|' + listId)) return;
        var items = g.boxes.map(function (b, i) { return gridItem(b, g, i + 1); }).filter(Boolean);
        if (!items.length) return;
        DL.push('view_item_list', base(C.grid.component_id, placement, {
          item_list_id: listId,
          item_list_name: g.item_list_name,
          list_batch_index: 1,
          exposure_rule: meta.rule,
          exposure_ratio: meta.ratio_observed,
          items: items
        }));
      });
    });

    if (initGrids.__bound) return;
    initGrids.__bound = 1;

    onClick(function (evt, t) {
      var found = gridOf(t);
      if (!found) return;
      var g = found.g, box = found.box, index = found.index;
      var listId = 'home_' + g.name;
      var placement = C.grid.placement + g.name;

      /* 加购按钮：只记录意图，等接口成功再上报 */
      if (t.closest('form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"]')) {
        lastAdd = { at: Date.now(), g: g, listId: listId, placement: placement, index: index };
        return true;
      }

      /* ⚠️ 不能用 box.querySelector 兜底找链接。
         ProductBox 里除了图和标题，还有价格、角标、数量、加购按钮。
         点在这些地方并不会打开 PDP，兜底会把它们统统记成
         element_id=product_card 的 select_item。
         线上实测：点 disabled 的「Próximamente」加购按钮就误发过一条 ——
         浏览器不给禁用控件派发 click，事件目标落到外层 div，
         既没命中加购分支，又被兜底捞成了商品卡点击，而 URL 纹丝不动。
         规则明确「禁用按钮不计成功点击」，这里只认两种情况：
           1) 点到了真正可跳转的元素；
           2) 整张卡本身就是链接。 */
      if (t.closest('button, [type="submit"], [type="button"], select, input, label, ' +
                    '[data-pf-type="ProductATC2"], [data-pf-type^="ProductPrice"]')) return;
      var link = t.closest('[data-href], a[href]');
      if (!link && (box.getAttribute('data-href') || box.getAttribute('href'))) link = box;
      var href = hrefOf(link);
      if (!href || !/\/products\//.test(href)) return;
      DL.afterTick(function () {
        var __np = DL.navPush(evt, link || box);
        if (!__np) return;
        var item = gridItem(box, g, index);
        if (!item) return;
        __np('select_item', base(C.grid.component_id, placement, {
          item_list_id: listId,
          item_list_name: g.item_list_name,
          /* 表格枚举：product_card|product_title|product_image */
          element_id: elementIdOfCardClick(t, box),
          index: index,
          destination_url: href,
          items: [item]
        }));
      });
      return true;
    });
  }

  function initAddToCart() {
    if (initAddToCart.__bound) return;
    initAddToCart.__bound = 1;

    DL.onCartSuccess(function (kind, body) {
      if (kind !== 'add') return;
      var ctx = lastAdd && Date.now() - lastAdd.at < 10000 ? lastAdd : null;
      if (!ctx) return;
      lastAdd = null;

      var lines = [];
      if (body && body.items && body.items.length) lines = body.items;
      else if (body && body.id) lines = [body];

      DL.fetchCart().then(function (cart) {
        if (!cart) return;
        var items = DL.itemsFromCartLines(lines, {
          item_list_id: ctx.listId, item_list_name: ctx.g.item_list_name, index: ctx.index
        });
        if (!items.length) return;
        DL.push('add_to_cart', base(C.grid.component_id, ctx.placement, {
          item_list_id: ctx.listId,
          item_list_name: ctx.g.item_list_name,
          element_id: 'quick_add',
          index: ctx.index,
          cart_type: (DL.ctx.cart_type === 'drawer' || DL.ctx.cart_type === 'notification') ? 'drawer' : 'page',
          value: DL.itemsValue(items),
          items: items
        }));
      });
    });
  }

  /* ================================================================ */
  /* H7 · 编辑型品类 CTA                                               */
  /* ================================================================ */

  /** H7 表格要求带 index：同一编辑型区域内的第几个入口 */
  function editorialIndex(link) {
    var list = MODULES.editorialLinks || [];
    var i = list.indexOf(link);
    return i > -1 ? i + 1 : undefined;
  }

  /** 去掉品类入口文案里的动作前缀，只留品类本身 */
  function cleanCatName(str) {
    return String(str || '')
      .replace(/^\s*(m[áa]s\s+informaci[óo]n|learn\s+more|saber\s+m[áa]s)\s*$/i, '')
      .replace(/^\s*(ver|ir a|descubre|explora|conoce)\s+(todos?\s+(los|las)\s+|todas?\s+las\s+)?/i, '')
      .replace(/^\s*(todos?\s+(los|las)|todas?\s+las)\s+/i, '')
      .replace(/\s*[>›»]\s*$/, '')
      .trim();
  }

  function initEditorial() {
    if (initEditorial.__bound) return;
    initEditorial.__bound = 1;

    onClick(function (evt, t) {
      /* ⚠️ 不看内部有没有 Button2 —— 实测两个断点都是「一半带、一半不带」，
         上一版按 Button2 判定，恒定丢掉「Más información / Ver …」那一半。 */
      var link = t.closest(PF.colLink);
      if (!link) return;
      if (link.closest(PF.contentList)) return;   /* 系列导航走 H3 */
      if (link.closest(PF.productBox)) return;    /* 商品卡走 H6 */
      if (gridOf(t)) return;

      var href = hrefOf(link);
      var handle = handleOf(href);
      /* 同一品类下两个入口用 element_id 区分：带筛选参数的是配件入口 */
      /* 表格枚举：card|cta_text|cta_arrow */
      var elementId = t.closest('svg, [class*="arrow"], [class*="chevron"]') ? 'cta_arrow'
                    : (t.closest('[data-pf-type="Button2"]') || /^\s*(ver|todos|más|mas)/i.test(txt(link))) ? 'cta_text'
                    : 'card';
      /* ⚠️ 整张卡是链接时 txt(link) 会把卡里所有文案连成一串 ——
         实测得到 "Más información Ver drones con cámara"，当品类名是错的。
         取名优先级：点到的那段短文案 → 卡内按钮 → 卡内最后一段文案 → handle，
         并剥掉 "Ver / Todos los / Más información" 这类动作前缀。 */
      var nameEl = t.closest('[data-pf-type="Button2"], [data-pf-type^="Paragraph"], h1, h2, h3, h4');
      var name = (nameEl && link.contains(nameEl)) ? cleanCatName(txt(nameEl)) : '';
      if (!name) {
        var btnEl = link.querySelector('[data-pf-type="Button2"]');
        if (btnEl) name = cleanCatName(txt(btnEl));
      }
      if (!name) {
        var ps = all(link, '[data-pf-type^="Paragraph"]');
        if (ps.length) name = cleanCatName(txt(ps[ps.length - 1]));
      }
      if (!name || name.length > 40) name = handle.replace(/-/g, ' ');

      DL.afterTick(function () {
        var __np = DL.navPush(evt, link);
        if (!__np) return;
        __np('category_entry_click', base(
          C.editorial.component_id,
          C.editorial.placement + (handle ? slug(handle) : 'category'), {
            category_id: handle || undefined,
            category_name: name || undefined,
            element_id: elementId,
            destination_url: href,
            index: editorialIndex(link)
          }));
      });
      return true;
    });
  }

  /* ================================================================ */
  /* H8 · 首页阅读深度                                                 */
  /* ================================================================ */

  function initScrollDepth() {
    if (initScrollDepth.__bound) return;
    initScrollDepth.__bound = 1;
    DL.scrollDepth({ thresholds: [30, 50, 70, 100], key: 'home_scroll' }, function (pct) {
      DL.push('home_scroll_depth', base(C.scroll.component_id, C.scroll.placement, {
        scroll_percent: pct,
        scroll_method: 'document',
        device_type: DL.deviceType(),
        page_language: DL.ctx.locale || undefined
      }));
    });
  }

  /* ================================================================ */
  /* 启动                                                              */
  /* ================================================================ */

  function wire() {
    MODULES = discover();

    if (MODULES.hero) initHero(MODULES.hero);
    initNewsletter(MODULES.newsletterForms);
    initSeriesNav(MODULES.seriesLists);
    initService();
    initCategoryHero(MODULES.catHeroes);
    initGrids(MODULES.grids);
    initAddToCart();
    initEditorial();

    DL.log('home modules', {
      hero: !!MODULES.hero,
      newsletter: MODULES.newsletterForms.length,
      series: MODULES.seriesLists.length,
      service: MODULES.serviceTriggers.length,
      grids: MODULES.grids.map(function (g) { return g.name + '(' + g.boxes.length + ')'; }),
      catHeroes: MODULES.catHeroes.length,
      editorial: MODULES.editorialLinks.length
    });
  }

  function start() {
    if (start.__done) return;
    start.__done = 1;
    wire();
    emitNewsletterSuccess();
    initScrollDepth();

    /* PageFly 会在首屏之后懒加载补渲染；旋转屏幕跨断点也会换掉整批可见 section。
       重新发现一次，已绑定的靠 __dji* 标记跳过，不会重复绑定。 */
    var rescan = null;
    function scheduleRescan() {
      if (rescan) w.clearTimeout(rescan);
      rescan = w.setTimeout(wire, 600);
    }
    try {
      new MutationObserver(scheduleRescan).observe(d.body, { childList: true, subtree: true });
    } catch (e) {}
    w.addEventListener('resize', scheduleRescan, { passive: true });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();

  DL.log('home tracking ready');
})(window, document);
